<template>

    <Toast/>

    <MenuMain v-if="this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0)"/>
    <MenuMain v-if="this.userStore.user.roles.includes('ROLE_ISOEVOLVE', 0)"/>
    <MenuUserModuleMain v-if="this.userStore.user.roles.includes('ROLE_USER', 0)"/>
    <HeadingApplications/>

    <div class="px-6 surface-overlay relative">


        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Private Practice 101 (South Africa)</h3>

                    <Accordion>
                        <AccordionTab header="Module #1 :: Getting your Private Practice Number">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Getting your Private Practice Number</h2>

                                        To get your practice number you will need to apply for it through the Practice
                                        Code Numbering System
                                        (PCNS) with the Board of Healthcare Funders (BHF).
                                        If you follow the information below, our team will help you with this process.

                                        <br><br>
                                        Note that this process can only be started once you have your registration
                                        confirmation with the
                                        HPCSA.

                                        <br><br>
                                        <h3>Documents Required for Practice Number Application</h3>
                                        - Certified copy of your ID Book/Card
                                        <br>
                                        - Certified copy of your HPCSA Independent Practice Registration Certificate
                                        <br>
                                        - Proof from the HPCSA that your fees are up to date. (This can be the statement
                                        downloaded from the
                                        HPCSA portal)

                                        <br><br>
                                        <h3>Application Forms for the Practice Number</h3>
                                        - Please email us the documents listed above to info@kitrin.com.
                                        <br>
                                        - Our team will then prepare your application form, and send this to you for
                                        review and signature,
                                        within three (3) working days of receipt of the documents.
                                        <br>
                                        - Once the completed form is emailed back to us at info@kitrin.com, our team
                                        will do final checks
                                        and submit the application to the BHF within
                                        three (3) working days of receipt of the signed application form.. It will take
                                        between 10 to 20
                                        working days for the application to be
                                        reviewed and approved by the BHF.

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Module #2 :: Registering with Medical Aids">
                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Registering with Medical Aids</h2>

                                        There are medical aid companies in South Africa, and there are administrators of
                                        medical aid
                                        companies. In some cases,
                                        these are one and the same. However, in most cases, the medical aid is
                                        administered by an external
                                        administrator. This means
                                        that if one registers with the medical aid administrator, it is highly likely
                                        that the you would
                                        then be registered across
                                        all medical aid schemes that they administer.

                                        <br><br>
                                        Based on this information, we strongly advise you to prioritise the following
                                        registrations listed
                                        below (which our team will assist with),
                                        and then handle each of the other registrations as you need to in terms of
                                        patients that you will
                                        encounter in your private
                                        practice. Since you have four months from the date of service and most
                                        registrations with medical
                                        aid companies take 4-6 weeks,
                                        you should have amply time to submit the registration for the medical aid
                                        scheme. This approach will
                                        allow you to be registered
                                        with around 100 medical aid schemes within a short time period.

                                        <br><br>
                                        Note that this process can only be started once you have your practice number
                                        confirmation from the
                                        BHF.

                                        <br><br>
                                        <h3>Documents Required for Medical Aid Registrations</h3>
                                        - Certified copy of your ID Book/Card
                                        <br>
                                        - Certified copy of your HPCSA Independent Practice Registration Certificate
                                        <br>
                                        - Proof from the HPCSA that your fees are up to date. (This can be the statement
                                        downloaded from the
                                        HPCSA portal)
                                        <br>
                                        - Proof from the BHF of your practice number.
                                        <br>
                                        - Proof of the bank account for your private practice.

                                        <br><br>
                                        <h3>Application Forms for the Medical Aid Registration</h3>
                                        - Please email us the documents listed above to info@kitrin.com.
                                        <br>
                                        - Our team will then prepare your registration forms, and send this to you for
                                        review and signature,
                                        within five (5) working days of receipt of the documents.
                                        <br>
                                        - Once the completed form is emailed back to us at info@kitrin.com, our team
                                        will do final checks
                                        and submit the application to each of the
                                        medical aid companies within five (5) working days of receipt of the signed
                                        registration forms.
                                        It will take between 15 to 30 working days for the registrations to be reviewed
                                        and approved by each
                                        medical aid scheme.

                                        <br><br>
                                        <h3>1. Discovery (29 medical aid schemes)</h3>
                                        a. AFRISAM
                                        <br>
                                        b. ALTRON
                                        <br>
                                        c. ANGLO MEDICAL SCHEME
                                        <br>
                                        d. ANGLO VAAL
                                        <br>
                                        e. FLEXICARE CORPORATE (DISCOVERY)
                                        <br>
                                        f. BANKMED
                                        <br>
                                        g. BMW
                                        <br>
                                        h. DISCOVERY
                                        <br>
                                        i. DISCOVERY KEYCARE
                                        <br>
                                        j. DEPARTMENT OF HEALTH -DISCOVERY
                                        <br>
                                        k. EDCON
                                        <br>
                                        l. GLENCORE
                                        <br>
                                        m. IBM
                                        <br>
                                        n. LA HEALTH
                                        <br>
                                        o. LA HEALTH KEYCARE
                                        <br>
                                        p. LONMIN
                                        <br>
                                        q. MALCOR
                                        <br>
                                        r. MULTICHOICE - NASPERS - MMED
                                        <br>
                                        s. NETCARE
                                        <br>
                                        t. QUANTUM
                                        <br>
                                        u. QUANTUM KEYCARE
                                        <br>
                                        v. REMEDI
                                        <br>
                                        w. RETAIL
                                        <br>
                                        x. SAB - SABMAS
                                        <br>
                                        y. SASOLMED
                                        <br>
                                        z. TFG
                                        <br>
                                        aa. TSOGO
                                        <br>
                                        ab. UNIVERSITY OF KZN
                                        <br>
                                        ac. WITSMED (UNIVERSITY OF WITWATERSRAND)

                                        <br><br>
                                        <h3>2. Medscheme (27 medical aid schemes)</h3>
                                        a. AECI (COMPREHENSIVE, COMPREHENSIVE SELECT AND VALUE OPTION )
                                        <br>
                                        b. AECI VALUE
                                        <br>
                                        c. AFA BROADREACH
                                        <br>
                                        d. AFA CORPORATE
                                        <br>
                                        e. BARLOWORLD
                                        <br>
                                        f. BONITAS
                                        <br>
                                        g. BONITAS (BONESSENTIAL & BONESSENTIAL SELECT)
                                        <br>
                                        h. COMMED
                                        <br>
                                        i. COMMED ROOTS
                                        <br>
                                        j. DEPARTMENT OF HEALTH -MEDSCHEME
                                        <br>
                                        k. ELLERINE HOLDINGS
                                        <br>
                                        l. FEDHEALTH
                                        <br>
                                        m. HORIZON
                                        <br>
                                        n. HOSMED
                                        <br>
                                        o. HOSMED ACCESS + ESSENTIAL
                                        <br>
                                        p. HOSMED -ESSENTIAL OPTION
                                        <br>
                                        q. LIBERTY
                                        <br>
                                        r. LIBERTY TRADITIONAL BASIC
                                        <br>
                                        s. MBMED
                                        <br>
                                        t. NEDGROUP
                                        <br>
                                        u. ONECARE - NEDGROUP
                                        <br>
                                        v. PARMED
                                        <br>
                                        w. POLMED
                                        <br>
                                        x. SABC
                                        <br>
                                        y. TOPMED
                                        <br>
                                        z. TOPMED NETWORK (use FEDHEALTH code F001)
                                        <br>
                                        aa. BONITAS (BONESSENTIAL & BONESSENTIAL SELECT)

                                        <br><br>
                                        <h3>3. MHG (Metropolitan Health Group) (6 medical aid schemes)</h3>
                                        a. BOPHELO Metropolitan Lesotho
                                        <br>
                                        b. GEMS BERYL & TANZANITE
                                        <br>
                                        c. GEMS EMERALD ONYX & RUBY
                                        <br>
                                        d. DEPARTMENT OF HEALTH -MHG-WESTERN CAPE
                                        <br>
                                        e. DEPARTMENT OF HEALTH -MHG -GAUTENG
                                        <br>
                                        f. MEDIPOS

                                        <br><br>
                                        <h3>4. MMI (8 medical aid schemes)</h3>
                                        a. BP
                                        <br>
                                        b. ENGEN
                                        <br>
                                        c. FISHMED
                                        <br>
                                        d. GOLDEN ARROW
                                        <br>
                                        e. IMPERIALMED
                                        <br>
                                        f. METROPOLITAN HEALTH / STAFF
                                        <br>
                                        g. PG GROUP
                                        <br>
                                        h. PICK AND PAY

                                        <br><br>
                                        <h3>5. MOMENTUM CONS (7 medical aid schemes)</h3>
                                        a. BOTSOGO
                                        <br>
                                        b. HEALTH4ME
                                        <br>
                                        c. MOMENTUM
                                        <br>
                                        d. MOTO HEALTHCARE ( CLASSIC & OPTIMUM)
                                        <br>
                                        e. TRANSMED GUARDIAN PLAN
                                        <br>
                                        f. TRANSMED PRIME PLAN (PRIVATE NETWORK PLAN)
                                        <br>
                                        g. WOOLTRU (Saver and Comprehensive Option )

                                        <br><br>
                                        <h3>6. MOMENTUM THEBE YA BOPHELO (2 medical aid schemes)</h3>
                                        a. ANGLOGOLD ASHANTI
                                        <br>
                                        b. THEBEMED

                                        <br><br>
                                        <h3>7. UNIVERSAL (20 medical aid schemes)</h3>
                                        a. Universal Health & Accident Plan (UHAP)
                                        <br>
                                        b. BCIMA (Building & Construction Industry)
                                        <br>
                                        c. BCIMA (PLUS OPTION )
                                        <br>
                                        d. COMPCARE MEDICAL SCHEME
                                        <br>
                                        e. FLIMAS - Fidelity Life Medical Aid Society
                                        <br>
                                        f. GRINTEK
                                        <br>
                                        g. HOSMED VALUE CORE
                                        <br>
                                        h. IMPILO - UNIVERSAL
                                        <br>
                                        i. MASSMART
                                        <br>
                                        j. MEDIONE SICK FUND
                                        <br>
                                        k. MASSMART EMS
                                        <br>
                                        l. OLD MUTUAL STAFF - NETWORK PLAN & SELECT PLAN
                                        <br>
                                        m. REEBOKRANT WORKERS TRUST
                                        <br>
                                        n. TIGER BRANDS
                                        <br>
                                        o. TRANSMED LINK PLAN ( STATE PLUS NETWORK)
                                        <br>
                                        p. UNIVERSAL WELLNESS
                                        <br>
                                        q. UNIVERSAL HEATLH ACCIDENT
                                        <br>
                                        r. WORKPLACE HEALTH PLAN (WORKERPLAN)
                                        <br>
                                        s. NTSIKA (WCMAS)
                                        <br>
                                        t. Watch Tower

                                    </div>

                                </div>
                            </div>
                        </AccordionTab>


                        <AccordionTab header="Module #3 :: Private Practice Management Course">


                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Private Practice Management Course</h2>

                                        Accreditation number : AOCP001/5734/12/2025<br>

                                        5 Ethics CEUs, HPCSA Level 1<br>

                                        <br><br>
                                        The running of a healthcare private practice is a difficult transition for most
                                        healthcare
                                        practitioners.
                                        In this course, we review the HPCSA
                                        guidelines and provide insight and actionable learnings to help any healthcare
                                        practitioner
                                        with
                                        their
                                        private practice management.

                                        <br><br>
                                        Our Presenter, Ingrid James, will be introducing the concepts, as well as
                                        discussing the
                                        applications of
                                        each area within a healthcare private practice.

                                        <br><br>
                                        <h3>Aims of the Programme</h3>
                                        1. Strategy and mapping out your journey.<br>
                                        2. Ethical considerations.<br>
                                        3. Marketing considerations.<br>
                                        4. Legal considerations.<br>
                                        5. People and human resources considerations.<br>
                                        6. Processes and operational functional considerations.<br>
                                        7. Billing, financials and tax considerations.<br>
                                        8. Continuous learning and educational considerations.<br>
                                        9. Coaching and mentorship considerations.<br>
                                        10. Tools and resources.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Ingrid James</h3>
                                        Clinical Psychologist<br>
                                        MA (Clin Psychology) Zululand<br>

                                        <br><br>
                                        Ingrid is a Senior Clinical Psychologist, with special interest in the
                                        maintenance of
                                        well-being and
                                        the
                                        prevention of mental illness.
                                        She has been in private practice since 2005 based in Gauteng, South Africa.

                                        <br><br>
                                        She trained at the University of Zululand in a community psychology based
                                        programme.
                                        Zululand in
                                        Northern
                                        KwaZulu Natal and its
                                        surrounding areas is a predominantly mining area where supporting towns sprang
                                        up as a
                                        result of
                                        migrant
                                        employees. The aim of
                                        the University in developing the community psychology programme was to create
                                        support for
                                        the
                                        displaced
                                        migrant employees,
                                        facilitate tolerance in this cultural melting pot, and most of all create an
                                        environment of
                                        physical
                                        and
                                        emotional well-being
                                        for the employees and their families.

                                        <br><br>
                                        She was initially moved to concentrate on well-being and prevention of mental
                                        illness during
                                        my
                                        internship
                                        where I worked
                                        as a consultant psychologist to companies such as Mondi (Richards Bay and
                                        Empangeni), South
                                        African
                                        Ports
                                        Authority (Portnet),
                                        Ticor and Richards Bay Coal Terminal (RBCT). She was responsible for the
                                        Employee Assistance
                                        Programme
                                        (EAP) in each of these
                                        companies and was confronted on a daily basis with individuals who struggled to
                                        cope with
                                        their
                                        unfamiliar
                                        environments and
                                        the demands of work. The research for her Master’s Thesis was The Effect of
                                        Exercise on
                                        Psychological
                                        Well-Being in the Workplace.

                                        <br><br>
                                        During the course of her practice, she has dealt with a number of clients with
                                        work related
                                        difficulties.
                                        She was instrumental
                                        in establishing the EAP programme in a medical hospital during my Community
                                        Service. After
                                        establishing a
                                        successful private practice,
                                        she branched out into Coaching and received accreditation through Success
                                        Factory. This was
                                        mainly
                                        due to
                                        the yearning to be able to
                                        intervene at an earlier stage of distress.

                                        <br><br>
                                        She is an internationally accredited assessor of the EQ-i and MBTI New. Her
                                        training as a
                                        clinical
                                        psychologist, exposure to
                                        coaching and work experience equips her to understand the relationships of
                                        individuals both
                                        with
                                        themselves and each other.
                                        She excels at managing difficult situations through her attitude,
                                        professionalism and
                                        ethical point
                                        of
                                        view.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 0825576793<br>
                                        Practice Address :: 55A Albatross Drive, Fourways, Gauteng, 2055<br>
                                        Email :: ingrid@ingridnagaya.com<br>
                                        Website:: www.ingridnagaya.com

                                        <br><br><br><br>
                                        <h3>Watch Video for Module #1</h3>
                                        <div>
                                            <div class="video-container">
                                                <iframe width="640" height="480"
                                                        src="https://www.youtube.com/embed/19b-13Gac5s"
                                                        frameborder="0"
                                                        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                        allowfullscreen></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Watch Video for Module #2</h3>
                                        <div>
                                            <div class="video-container">
                                                <iframe width="640" height="480"
                                                        src="https://www.youtube.com/embed/V3ywRZXlK-U"
                                                        frameborder="0"
                                                        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                        allowfullscreen></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Watch Video for Module #3</h3>
                                        <div>
                                            <div class="video-container">
                                                <iframe width="640" height="480"
                                                        src="https://www.youtube.com/embed/rH6pl_h4yl4"
                                                        frameborder="0"
                                                        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                        allowfullscreen></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Watch Video for Module #4</h3>
                                        <div>
                                            <div class="video-container">
                                                <iframe width="640" height="480"
                                                        src="https://www.youtube.com/embed/gEnHxpYwwn0"
                                                        frameborder="0"
                                                        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                        allowfullscreen></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Watch Video for Module #5</h3>
                                        <div>
                                            <div class="video-container">
                                                <iframe width="640" height="480"
                                                        src="https://www.youtube.com/embed/g_vayAPTL3s"
                                                        frameborder="0"
                                                        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                                        allowfullscreen></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Module #1</h3>
                                        <div>
                                            <iframe width="100%" height="300" scrolling="no" frameborder="no"
                                                    allow="autoplay"
                                                    src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1333001971&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
                                            <div
                                                style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;">
                                                <a href="https://soundcloud.com/kitrin01" title="KITRIN" target="_blank"
                                                   style="color: #cccccc; text-decoration: none;">KITRIN</a> · <a
                                                href="https://soundcloud.com/kitrin01/kitrin-isolearn-private-practice-management-module-41"
                                                title="Kitrin IsoLearn :: Private Practice Management :: Module 4.1"
                                                target="_blank"
                                                style="color: #cccccc; text-decoration: none;">Kitrin IsoLearn ::
                                                Private Practice
                                                Management :: Module 4.1</a></div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Module #2</h3>
                                        <div>
                                            <iframe width="100%" height="300" scrolling="no" frameborder="no"
                                                    allow="autoplay"
                                                    src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1333002253&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
                                            <div
                                                style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;">
                                                <a href="https://soundcloud.com/kitrin01" title="KITRIN" target="_blank"
                                                   style="color: #cccccc; text-decoration: none;">KITRIN</a> · <a
                                                href="https://soundcloud.com/kitrin01/kitrin-isolearn-private-practice-management-module-42"
                                                title="Kitrin IsoLearn :: Private Practice Management :: Module 4.2"
                                                target="_blank"
                                                style="color: #cccccc; text-decoration: none;">Kitrin IsoLearn ::
                                                Private Practice
                                                Management :: Module 4.2</a></div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Module #3</h3>
                                        <div>
                                            <iframe width="100%" height="300" scrolling="no" frameborder="no"
                                                    allow="autoplay"
                                                    src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1333002754&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
                                            <div
                                                style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;">
                                                <a href="https://soundcloud.com/kitrin01" title="KITRIN" target="_blank"
                                                   style="color: #cccccc; text-decoration: none;">KITRIN</a> · <a
                                                href="https://soundcloud.com/kitrin01/kitrin-isolearn-private-practice-management-module-43"
                                                title="Kitrin IsoLearn :: Private Practice Management :: Module 4.3"
                                                target="_blank"
                                                style="color: #cccccc; text-decoration: none;">Kitrin IsoLearn ::
                                                Private Practice
                                                Management :: Module 4.3</a></div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Module #4</h3>
                                        <div>
                                            <iframe width="100%" height="300" scrolling="no" frameborder="no"
                                                    allow="autoplay"
                                                    src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1333003717&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
                                            <div
                                                style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;">
                                                <a href="https://soundcloud.com/kitrin01" title="KITRIN" target="_blank"
                                                   style="color: #cccccc; text-decoration: none;">KITRIN</a> · <a
                                                href="https://soundcloud.com/kitrin01/kitrin-isolearn-private-practice-management-module-44"
                                                title="Kitrin IsoLearn :: Private Practice Management :: Module 4.4"
                                                target="_blank"
                                                style="color: #cccccc; text-decoration: none;">Kitrin IsoLearn ::
                                                Private Practice
                                                Management :: Module 4.4</a></div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Module #5</h3>
                                        <div>
                                            <iframe width="100%" height="300" scrolling="no" frameborder="no"
                                                    allow="autoplay"
                                                    src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1333004299&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
                                            <div
                                                style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;">
                                                <a href="https://soundcloud.com/kitrin01" title="KITRIN" target="_blank"
                                                   style="color: #cccccc; text-decoration: none;">KITRIN</a> · <a
                                                href="https://soundcloud.com/kitrin01/kitrin-isolearn-private-practice-management-module-45"
                                                title="Kitrin IsoLearn :: Private Practice Management :: Module 4.5"
                                                target="_blank"
                                                style="color: #cccccc; text-decoration: none;">Kitrin IsoLearn ::
                                                Private Practice
                                                Management :: Module 4.5</a></div>
                                        </div>

                                        <div>
                                            <br><br><br><br>
                                            <h3>Complete Questionnaire for Course</h3>

                                            <div class="field">
                                                <label for="question1">1. Can you use the expression "hospital",
                                                    "clinic" or
                                                    "institute" in
                                                    your practice name?</label>
                                                <Dropdown v-model="module1.answer1" :options="module1Question1"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. How many core ethical values and standards are
                                                    there in
                                                    terms of
                                                    clinical practice?</label>
                                                <Dropdown v-model="module1.answer2" :options="module1Question2"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Can information on a patient be shared on
                                                    social media
                                                    platforms
                                                    (if no consent is received from patient)?</label>
                                                <Dropdown v-model="module1.answer3" :options="module1Question3"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Can a practitioner divulge information
                                                    regarding a patient
                                                    under
                                                    certain circumstances?</label>
                                                <Dropdown v-model="module1.answer4" :options="module1Question4"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. How long can a practitioner employ a locum
                                                    tenen?</label>
                                                <Dropdown v-model="module1.answer5" :options="module1Question5"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireModule1"></Button>
                                        </div>

                                    </div>
                                </div>
                            </div>


                        </AccordionTab>

                        <AccordionTab header="Module #4 :: Previous Weekly Client Support Meetings">
                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Previous Weekly Client Support Meetings</h2>

                                        <iframe src="https://player.vimeo.com/video/932027965?h=1497dec4ec&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="Kitrin Client Support Meeting :: 08-JAN-2024"></iframe>

                                        <br><br>
                                        <iframe src="https://player.vimeo.com/video/932072957?h=72ac8860bc&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="640" height="480" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="Kitrin Client Support Meeting :: 14-NOV-2023"></iframe>

                                        <br><br>
                                        <iframe src="https://player.vimeo.com/video/932097761?h=46053ec30c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="Kitrin Client Support Meeting :: 29-JAN-2024"></iframe>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Module #5 :: Interviews with Other Healthcare Practitioners in Private Practice">
                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Interviews with Other Healthcare Practitioners in Private Practice</h2>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/0bZE8e0xcu3xK0OrAZCQjw?utm_source=generator&theme=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/7Fs8IqMvSS5axIjYEF5iLa?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/4fPvig5ed4YGMVKupDSE5L?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/0yKUtCswwiqJGe012xF23I?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <!--                    <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/0yKUtCswwiqJGe012xF23I?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>-->

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/0k3rOwYbSFO1u4NIWuebei?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/4pLZ0jXOmYQAQsciAqO8kO?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/6ccCDfJUQHRkhPIgcc503a?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/4qY6uXVnNvUb1aRjTPm2VK?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/7KiYLy26kB04xX6WbeP5xu?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/4tpgBjwfsW71bJ2twf9a0x?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/7mxDMTZkwcgGoGXzvhTFHF?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/6FM1lpPRIXaiAwvFmIatET?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/2aDGwAFj48giKgxEwkUos2?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/1ffjia6oF4GIzW2UNpB9d4?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/7l7LnNWIfp9aemDDPkaMP6?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/5F3RSgzkRZ8gNSYrqBZIWw?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/7EUsKL9EwDOtucgetwlO5U?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/513p7rzWcArzFYveCT2wsF?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/5ANbWdPoSvmjfKqxR2EJJG?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/7g4aOuwEoKe56bWifd9Tn4?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/5CRHMrBzA2llOVERmfYoai?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/7pI1ezjagcbSIS5lQOjnxz?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/4K0UuaI0iv1rX7mNmPnC3E?utm_source=generator&theme=0&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                        <iframe style="border-radius:12px" src="https://open.spotify.com/embed/episode/4aOq0dJIJKJODLaGBOHvBv?utm_source=generator&t=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Module #6 :: Access to IsoEvolve Practice Management Software">
                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Access to IsoEvolve Practice Management Software</h2>

                                        You have three (3) months access to the IsoEvolve Adaptive Practice Management Software, to
                                        allow you
                                        to start your private practice with all features for
                                        your private practice. If you already have a subscription to the product, your current
                                        subscription
                                        will be put on hold until the three (3) months expire.
                                        <br><br>
                                        If you don't already have access to the IsoEvolve Adaptive Practice Management Software, our
                                        enable
                                        will enable this functionality on your existing IsoEvolve account.
                                        <br><br>
                                        If you have any questions or concerns related to this access, please send an email to
                                        info@kitrin.com.

                                        <br><br><br>
                                        <h3>Training Video of IsoEvolve PM Module</h3>
                                        <div>
                                            <div class="video-container">
                                                <iframe
                                                    src="https://player.vimeo.com/video/888740629?h=e10063dac5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                    width="640" height="360" frameborder="0"
                                                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                                    title="IsoEvolve Practice Management Module :: Setup and Configuration"></iframe>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                    </Accordion>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>


<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import HeadingApplications from "@/components/heading/common/HeadingApplications.vue";
import MenuMain from "@/components/menu/common/MenuMain.vue";
import MenuUserModuleMain from "@/components/menu/usermodule/MenuUserModuleMain.vue";
import CourseAssessmentService from "@/service/CourseAssessmentService";


export default {
    components: {
        MenuUserModuleMain, HeadingApplications, MenuMain,
        IsoEvolveFooter
    },

    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        try {
            if (!this.userStore.user) {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            }

            this.profile = this.userStore.user;


            if (!this.userStore.userConfiguration) {
                const userConfigurationData = await UserService.getUserConfig(this.userStore.user.id);
                this.userStore.setUserConfiguration(userConfigurationData.data);
            }

            this.userConfiguration = this.userStore.userConfiguration;
        } catch (e) {
            console.error("[AppointmentsNew][mounted] Error fetching additional data = ", e);
        }
    },
    data() {
        return {
            profile: {},
            submitted: false,
            activeTab: 1,
            userConfiguration: {},
            module1: {},
            module1Question1: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            module1Question2: [
                {name: 'A. One', code: 'A'},
                {name: 'B. Five', code: 'B'},
                {name: 'C. Thirteen', code: 'C'},
                {name: 'D. Sixteen', code: 'D'},
                {name: 'E. Twenty', code: 'E'},
            ],
            module1Question3: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            module1Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            module1Question5: [
                {name: 'A. One Month', code: 'A'},
                {name: 'B. One Year', code: 'B'},
                {name: 'C. Six Months', code: 'C'},
                {name: 'D. Six Years', code: 'D'},
                {name: 'E. Nine Months', code: 'E'},
            ],
        }
    },
    methods: {
        submitQuestionnaireModule1() {
            console.log(this.module1);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.module1.answer1,
                answer2: this.module1.answer2,
                answer3: this.module1.answer3,
                answer4: this.module1.answer4,
                answer5: this.module1.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 125, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdModule4][submitQuestionnaireModule1] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Module 4. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdModule4][submitQuestionnaireModule1] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Module 4. Answers are NOT Correct.",
                        life: 3000
                    })
                });


        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
<script setup>
</script>
